import { useTranslation } from "react-i18next";
import { styled } from "@mui/material";
import { Button, SmallText, TextFieldCustom, Title } from "components";
import { FETCH_STATE } from "constants/fetchState";
import { useActionComments } from "../utils/useActionComments";
import ActionComment from "./ActionComment";
const CommentsSectionStyled = styled("div")({
  width: "100%",
  "& .comments-title": {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
  },
  "& .submit-comment-btn": {
    alignSelf: "flex-end",
  },
  "& .comments-section": {
    marginTop: "1rem",
    paddingLeft: "0.5rem",
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
    "& .toggle-more": {
      all: "unset",
      cursor: "pointer",
      marginRight: "1rem",
      "&:hover": {
        fontWeight: 600,
        textDecoration: "underline",
      },
    },
    "& ul.comments-list": {
      width: "100%",
      listStyleType: "none",
      "& li": {
        paddingBottom: "1rem",
      },
    },
  },
});

const ActionCommentsSection = () => {
  const { t } = useTranslation();
  const {
    addComment,
    showOlder,
    hideOlder,
    commentRef,
    fetchState,
    comments,
    displayedComments,
    commentsRemaining,
    couldHideOlder,
  } = useActionComments();

  const isLoading = fetchState === FETCH_STATE.LOADING;
  // const isError = fetchState === FETCH_STATE.ERROR;

  return (
    <CommentsSectionStyled>
      <div className="comments-title">
        <Title>{t("ActionModal.Comments.Title")}</Title>
        <Title sx={{ fontSize: "16px" }}>{`(${comments?.length})`}</Title>
      </div>
      <div className="comments-section">
        <span>
          {Boolean(commentsRemaining) && (
            <button onClick={showOlder} className="toggle-more">
              <SmallText>
                {t("ActionModal.Comments.ShowOlder", {
                  count: commentsRemaining,
                })}
              </SmallText>
            </button>
          )}
          {Boolean(couldHideOlder) && (
            <button onClick={hideOlder} className="toggle-more">
              <SmallText>{t("ActionModal.Comments.HideOlder")}</SmallText>
            </button>
          )}
        </span>
        <ul className="comments-list">
          {displayedComments.map((comment) => (
            <li key={comment.id}>
              <ActionComment comment={comment} />
            </li>
          ))}
        </ul>
        <TextFieldCustom
          inputRef={commentRef}
          placeholder={t("ActionModal.Comments.Placeholder")}
          minRows={2}
          isMultiline
          // {...(isError && {
          //   helperText: t("ActionModal.Comments.Error"),
          // })}
          // isError={isError}
        />
        <Button
          isLoading={isLoading}
          isDisabled={isLoading}
          className="submit-comment-btn"
          onClick={addComment}
        >
          {t("ActionModal.Comments.SubmitBtn")}
        </Button>
      </div>
    </CommentsSectionStyled>
  );
};

export default ActionCommentsSection;
